import { Switch, FormControlLabel, SwitchProps } from '@mui/material';
import { JSXElementConstructor, ReactElement } from 'react';

const defaultStyles = {
  width: 28,
  height: 16,
  padding: 0,
  marginRight: 0.5,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 0.2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        border: 0,
        backgroundColor: 'primaryLight.400',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    backgroundColor: 'white',
    borderRadius: 6,
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'primaryDark.300',
  },
};

type Props = {
  label: string | number | ReactElement<any, string | JSXElementConstructor<any>>;
} & SwitchProps;

const CustomSwitchInput = ({ label, sx, ...switchProps }: Props) => (
  <FormControlLabel
    control={<Switch sx={{ ...defaultStyles, ...sx }} {...switchProps} />}
    label={label}
  />
);

export default CustomSwitchInput;
